<template>
  <div class="text_list_item">
    <div class="title">
      {{ itemData.title }}
    </div>
    <div class="down_count">下载量:{{ itemData.views_count }}</div>
    <div class="down_btn" @click="downloadbtn()">下载</div>
  </div>
</template>
<script>
export default {
  name: "TextListItem",
  props: {
    itemData: {
      // type: Boolean,
      default: [],
    },
  },
  methods: {
    // downloadUrlFile(url, fileName) {
    //   const url2 = url.replace(/\\/g, "/");
    //   const xhr = new XMLHttpRequest();
    //   xhr.open("GET", url2, true);
    //   xhr.responseType = "blob";
    //   //如果希望文件名就是url斜杠最后的部分,则加上下面两行代码,fileName参数传url就行
    //   //var index = fileName .lastIndexOf("\/");
    //   //fileName  = fileName .substring(index + 1, fileName .length);
    //   // 为了避免大文件影响用户体验，建议加loading
    //   xhr.onload = () => {
    //     if (xhr.status === 200) {
    //       // 获取文件blob数据并保存
    //       download(xhr.response, fileName);
    //     }
    //   };
    //   xhr.send();
    // },
    // funDownload(content, filename) {
    //   // 创建隐藏的可下载链接
    //   var eleLink = document.createElement("a");
    //   eleLink.download = filename;
    //   eleLink.style.display = "none";
    //   // 字符内容转变成blob地址
    //   var blob = new Blob([content]);
    //   eleLink.href = URL.createObjectURL(blob);
    //   // 触发点击
    //   document.body.appendChild(eleLink);
    //   eleLink.click();
    //   // 然后移除
    //   document.body.removeChild(eleLink);
    // },
    downloadbtn() {
      var that = this;
      window.open(that.itemData.files[0].url, "_blank");
      // this.downloadUrlFile(that.itemData.files[0].url,that.itemData.title)
      that.$api.get(
        "/api/cms/detail",
        {
          id: this.itemData.id,
        },
        (res) => {
          this.$message.success("下载请求发送成功");
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
.text_list_item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 83px;
  line-height: 83px;
  border-bottom: 1px solid #e5e5e5;
  width: 1240px;
  padding-left: 48px;
  padding-right: 88px;
  box-sizing: border-box;
  .title {
    height: 20px;
    font-size: 14px;
    font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
      "\5FAE\8F6F\96C5\9ED1";
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    flex: 3.7;
  }
  .down_count {
    width: 100px;
    height: 20px;
    font-size: 14px;
    font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
      "\5FAE\8F6F\96C5\9ED1";
    font-weight: 500;
    color: #666666;
    line-height: 20px;
    flex: 3;
  }
  .down_btn {
    width: 93px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    background: #0091ff;
    border-radius: 10px;
    font-size: 14px;
    font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
      "\5FAE\8F6F\96C5\9ED1";
    font-weight: 500;
    color: #ffffff;
    &:hover {
      cursor: pointer;
      font-weight: bold;
    }
  }
}
</style>


// WEBPACK FOOTER //
// TextListItem.vue?198052ef